module.exports = __webpack_public_path__ + "static/media/curved-arrow.d70477c7.svg";